module.exports = __webpack_public_path__ + "img/CZ00001350.e6f94134.png";